import styled from "styled-components";
import { HeadLine1 } from "../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 10px 20px;
  position: relative;
`

export const InstanceName = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[800]};
  margin-top: 10px;
  margin-bottom: 10px;
`

export const NavWrapper = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-right: 10px;
  margin-top: 50px;
  & > div {
    position: absolute;
    bottom: -1px;
    left: 0px;
  }
`

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  gap: 50px;
  justify-content: space-between;
  width: 100%;
  margin-right: 10px;
`
